export default "__VITE_ASSET__9b05a73a__"